import React, { useEffect, useState, useRef } from 'react'
import { Button } from 'primereact/button';
import Spinner from '../../../components/loader/Spinner';
import TituloComponent from '../../../genericos/TituloComponent';
import { Service } from '../../../service/Service';
import Environment from '../../../Environment';
import { useParams } from 'react-router-dom';
import { CLIENTE } from '../../../genericos/Uris';
import { Calendar } from 'primereact/calendar';
import { InputText } from "primereact/inputtext";
import { Dialog } from 'primereact/dialog';
import { TextoAdvertencia } from '../ComponentsCat/Mensajes/Mensajes';
import { LICENCIAS_CLIENTE } from '../../../genericos/Uris';
import { BrowserRouter as router, useHistory } from 'react-router-dom';
import { Toast } from 'primereact/toast';

const ConfigLicencias = () => {

    const toast = useRef(null);

    const { id } = useParams();
    const [idPath, setIdPath] = useState(id);
    const getRoute = Environment();
    const clienteService = new Service();
    const [cliente, setCliente] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    const [fechaInicio, setFechaInicio] = useState("");
    const [fechaTermino, setFechaTermino] = useState("");
    const [maquinas, setMaquinas] = useState("");
    const [usuarios, setUsuarios] = useState("");
    const [dialog, setDialog] = useState(false);
    const [licenciaRepetida, setLiecenciaRepetida] = useState(false);

    const [texto, setTexto] = useState("");
    const [estiloUsuario, setEstiloUsuario] = useState("");
    const [estiloMaquina, setEstiloMaquina] = useState("");
    const [estiloFechaInicio, setEstiloFechaInicio] = useState("");
    const [estiloFechaFin, setEstiloFechaFin] = useState("");

    const serviceLicencia = new Service();

    useEffect(async () => {
        try {
            clienteService.baseUrl = `${getRoute}/${CLIENTE}`;
            const data = await clienteService.findById(idPath);
            setCliente(data)
            setIsLoading(false)
        } catch (e) {
            console.log(e)
        }
    }, [])

    const validate = () => {
        if (maquinas === "") {
            setEstiloMaquina("p-invalid");
            setTexto("Campo invalido");
            return;
        }
        if (usuarios === "") {
            setEstiloUsuario("p-invalid");
            setTexto("Campo invalido");
            return;
        }
        if (fechaInicio === "") {
            setEstiloFechaInicio("p-invalid");
            setTexto("Campo invalido");
            return;
        }
        if (fechaTermino === "") {
            setEstiloFechaFin("p-invalid");
            setTexto("Campo invalido");
            return;
        }
        setDialog(true);
    }

    const history = useHistory();

    const sendData = async () => {
        serviceLicencia.baseUrl = `${getRoute}/${LICENCIAS_CLIENTE}/${idPath}`;
        const obj = {
            maquinas: maquinas,
            usuarios: usuarios,
            fechaInicio: fechaInicio,
            fechaTermino: fechaTermino
        }
        try {
            setDialog(false);
            setIsLoading(true);
            await serviceLicencia.create(obj);
            setIsLoading(false);
            toast.current.show({ severity: 'success', summary: '¡Atención!', detail: "Se creó correctamente la licencia", life: 3000 });
            setTimeout(() => { history.push(`/catalogoClientes`) }, 2000);
        } catch (e) {
            setDialog(false);
            if (e.response.data.message === "El cliente ya cuenta con una licencia") {
                setLiecenciaRepetida(true);
            }
        }
    }

    const footerContent = () => {
        return (
            <div>
                <Button label="No" icon="pi pi-times" onClick={() => setDialog(false)} className="p-button-text" />
                <Button label="Si" icon="pi pi-check" onClick={sendData} autoFocus />
            </div>
        )
    }

    const close = () => {
        return (
            <div>
                <Button label="Ok" icon="pi pi-times" onClick={() => { setLiecenciaRepetida(false); history.push(`/catalogoClientes`); }} className="p-button-text" />
            </div>
        )
    }
    return (
        <>
            {isLoading && <Spinner />}
            {!isLoading &&
                <div className='card'>
                    <Toast ref={toast} />
                    <TituloComponent titulo={`Asignar licencia a ${cliente.nombreRazon}`} />
                    <div className="flex justify-content-between flex-wrap mt-5">
                        <div className="field col-12 md:col-6">
                            <span className="p-float-label">
                                <InputText id="maquinas" keyfilter="int" value={maquinas} onChange={(e) => { setMaquinas(e.target.value); setEstiloMaquina("") }} />
                                <label className="font-bold" htmlFor="maquinas">No Máquinas</label>
                            </span>
                            {estiloMaquina && <TextoAdvertencia>{texto}</TextoAdvertencia>}
                        </div>
                        <div className="field col-12 md:col-6">
                            <span className="p-float-label">
                                <InputText id="usuarios" keyfilter="int" value={usuarios} onChange={(e) => { setUsuarios(e.target.value); setEstiloUsuario("") }} />
                                <label className="font-bold" htmlFor="usuarios">No usuarios</label>
                            </span>
                            {estiloUsuario && <TextoAdvertencia>{texto}</TextoAdvertencia>}
                        </div>
                    </div>
                    <div className="flex justify-content-between flex-wrap mt-5 ">

                        <div className="field col-12 md:col-6">
                            <span className="p-float-label">
                                <Calendar
                                    id="finicio"
                                    dateFormat="yy/mm/dd"
                                    value={fechaInicio}
                                    onChange={(e) => { setFechaInicio(e.value); setEstiloFechaInicio("") }}
                                    showTime
                                />
                                <label className="font-bold" htmlFor="finicio">Fecha Inicio</label>
                            </span>
                            {estiloFechaInicio && <TextoAdvertencia>{texto}</TextoAdvertencia>}
                        </div>

                        <div className="field col-12 md:col-6">
                            <span className="p-float-label">
                                <Calendar
                                    id="time24"
                                    dateFormat="yy/mm/dd"
                                    value={fechaTermino}
                                    onChange={(e) => { setFechaTermino(e.value); setEstiloFechaFin("") }}
                                    showTime
                                />
                                <label className="font-bold" htmlFor="finicio">Fecha Termino</label>
                            </span>
                            {estiloFechaFin && <TextoAdvertencia>{texto}</TextoAdvertencia>}
                        </div>
                    </div>
                    <div className='mt-7 flex justify-content-around flex-wrap'>
                        <div className='flex align-items-center justify-content-center'>
                            <Button label="Cancelar" icon="pi pi-times" className="p-button-rounded" onClick={() => history.push(`/catalogoClientes`)} />
                        </div>
                        <div className='flex align-items-center justify-content-center'>
                            <Button label="Guardar" icon="pi pi-check" className="p-button-rounded" onClick={validate} />
                        </div>
                    </div>
                </div>
            }
            <Dialog visible={dialog} style={{ width: '550px' }} footer={footerContent} onHide={() => setDialog(false)} >
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-circle mr-3" style={{ fontSize: '2rem' }} />
                    {cliente && <span style={{ fontSize: '2rem' }}>¿Estás seguro de asignar una licencia a <b>{cliente.nombreRazon}</b>?</span>}
                </div>
            </Dialog>
            <Dialog visible={licenciaRepetida} style={{ width: '550px' }} footer={close} onHide={() => setLiecenciaRepetida(false)} >
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-circle mr-3" style={{ fontSize: '2rem' }} />
                    {cliente && <span style={{ fontSize: '2rem' }}><b>{cliente.nombreRazon}</b> Ya tiene una licencia asignada.</span>}
                </div>
            </Dialog>
        </>
    )
}

export default ConfigLicencias
